import { gql } from '@apollo/client';

export const validateQuery = gql`
  query validateApi($id: String!) {
    validate(id: $id) @rest(type: "Validate", path: "/redeem/validate/{args.id}", endpoint: "endpointvalidate") {
      result
    }
  }
`;
